import { FileObject, isFileObject } from "../../../files";
import { Layout } from "../layout.interface";
import { deepTraverseProps } from "./deep-traverse-props";

type FileTransfomer = (file: FileObject) => FileObject | undefined;

/**
 *
 * @param layout The layout to find files in
 * @param transformer Transformer function that tranforms the file before it is
 * added the the return array. If returning undefined the file does not end up
 * in the resulting array.
 */
export function deepFindFiles(
  layout: Layout | undefined,
  transformer?: FileTransfomer
): FileObject[] {
  if (!layout) return [];
  const files: FileObject[] = [];

  deepTraverseProps(layout, (prop) => {
    files.push(...extractFilesFromProp(prop, transformer));
  });

  return files;
}

/**
 * Extract files from prop and return a file object array
 * @param prop
 */
export function extractFilesFromProp(
  prop: any,
  transformer?: FileTransfomer
): FileObject[] {
  if (Array.isArray(prop)) {
    // Extract fileObjects from this array
    return [
      ...prop.reduce(
        (p, v) => p.concat(extractFilesFromProp(v, transformer)),
        []
      ),
    ];
  }

  if (typeof prop === "object" && prop) {
    if (isFileObject(prop)) {
      const file = transformer ? transformer(prop) : prop;
      // If the transformer returns undefined we'd return an empty array
      return file ? [file] : [];
    } else {
      // Recursively find files in this object
      return [...extractFilesFromProp(Object.values(prop), transformer)];
    }
  }
  // This is a primitive, return empty array
  return [];
}
